module.exports = __webpack_public_path__ + "img/icon-zhyj.6da385e5.png";